import dayjs from "dayjs";

const baseDate = dayjs().startOf("day");

const contractsDefaultFilters = {
  contractDateStartDate: baseDate.subtract(6, "month").toDate(),
  contractDateEndDate: baseDate.toDate(),
  contractDateType: "past6Months",
};

export default contractsDefaultFilters;
